// extracted by mini-css-extract-plugin
export default {"form":"CreateEventForm_form__2O0OS"};